import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBulkWhatsappInitialState } from "./bulkWhatsappModel";
import {
  findContactsByState,
  sendWhatsappBulkMessage,
  getWhatsAppTemplateApi,
} from "./services/bulkWhatsapp.services";

const initialState: IBulkWhatsappInitialState = {
  loading: false,
  sending: false,
  error: "",
  ContactList: [],
  apiTemplates: {},
};

const bulkWhatsappSlice = createSlice({
  name: "bulkWhatsapp",
  initialState,
  reducers: {
    clearBulkWhatsappState: (state) => {
      state.ContactList = [];
      state.apiTemplates = [];
      state.error = "";
      state.loading = false;
      state.sending = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findContactsByState.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.ContactList = [];
    });
    builder.addCase(
      findContactsByState.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.ContactList = action.payload || [];
      },
    );
    builder.addCase(findContactsByState.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ContactList = [];
    });
    builder.addCase(sendWhatsappBulkMessage.pending, (state) => {
      state.sending = true;
      state.error = "";
    });
    builder.addCase(sendWhatsappBulkMessage.fulfilled, (state) => {
      state.sending = false;
    });
    builder.addCase(sendWhatsappBulkMessage.rejected, (state, action) => {
      state.sending = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWhatsAppTemplateApi.fulfilled, (state, action) => {
      state.apiTemplates = action.payload;
    });
  },
});

export const { clearBulkWhatsappState } = bulkWhatsappSlice.actions;
export default bulkWhatsappSlice.reducer;
